<script>
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import Checkbox from '../../components/Checkbox.svelte';
    import PageSection from '../../components/PageSection.svelte';
    import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
    import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    import { pageNumber, model } from '../../stores';
    import { projectSettings } from '../../config';

    export let disabled = null;
    export let pageIndex = null;
    export let pageTitle = null;
    export let nextPage = null;
    export let lastVisitedPage = null;
    export let persistUrl = null;

    if (!disabled) {
        $model.LastPageVisited = lastVisitedPage;
        document.title = pageTitle;
        $pageNumber = pageIndex;

        //  Get the user Agent
        $model.UserAgent = navigator.userAgent;
        $model.referrer = document.referrer;
        $model.RegistrationSegmentId = null;
    }

</script>

<PageSection>
    <FormRow class="justify-content-center confirmation-hide">
        <FormColumn>
            <h1 class="text-center">{projectSettings.classActionName}</h1>
        </FormColumn>
	</FormRow>
	    	
    <FormRow class="justify-content-center confirmation-show">
	    <FormColumn>
		    <h2>&nbsp;</h2>
	    </FormColumn>
    </FormRow>

    <FormRow class="justify-content-md-center confirmation-hide">
        <FormColumn>
            <p>
                Shine Lawyers is investigating legal action against Cumberland Manor for alleged negligence over its handling of a fatal coronavirus outbreak at the facility.
            </p>
            <p>
                You are able to sign up to the class action investigation if:
            </p>
            <ul>
                <li>You have a family member or close relative that was a resident of Cumberland Manor during the outbreak of COVID-19 virus in 2020, and</li>
                <li>That family member or close relative passed away as a result of COVID-19.</li>
            </ul>
            <p>
                If you meet the criteria above, you may be entitled to compensation and you are encouraged to register for the {projectSettings.classActionName}.
            </p>

        </FormColumn>
    </FormRow>

	<div class="confirmation-box-shadow">
        <FormRow>
            <FormColumn>
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="mb-3">
                    Do you agree to provide us with personal information which will be kept confidential under the Shine Lawyers
                    <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>?
                </label>
                <Checkbox required="true" {disabled} bind:checked="{$model.privacyPolicyConfirmed}" label="I agree to the privacy policy" id="privacy"></Checkbox>
            </FormColumn>
        </FormRow>
    </div>

    <FormRow class="justify-content-md-center register-btn confirmation-hide">
        <FormColumn class="text-center">
            <NavigationButtons {persistUrl} showPrevious={false}
                    {nextPage}
                    nextPageLabel='REGISTER NOW'
                    disableNext={!$model.privacyPolicyConfirmed}></NavigationButtons>
        </FormColumn>
    </FormRow>

    <FormRow class="justify-content-md-center confirmation-hide">
        <FormColumn>
            <p>
                If you are in any doubt about whether you need to complete this form, or whether you
                have suffered damages, please contact Shine Lawyers on
                <ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
                <ClassActionEmailAddress></ClassActionEmailAddress>.
            </p>
        </FormColumn>
    </FormRow>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }

    li {
        display: list-item;
        list-style-image: url("data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"%3E%3Cpath fill=\"none\" stroke=\"red\" stroke-width=\"2\" d=\"M3 7.5L6 10.5L11 4.5\"%3E%3C/path%3E%3C/svg%3E")
    }
</style>


